import { lazy } from 'react';
import { PageRouter } from '@tools/ui/types';
import { VERIFICATION_TASKS_MAIN_TABS } from '../pages/verification-tasks/i18.verification-tasks';

const VerificationTasksTableDisplay = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/verification-tasks/VerificationTasksTableDisplay'
    )
);

const EscalatedTab = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/verification-tasks/inbox/tabs/escalated/EscalatedTab'
    )
);

const DoneTab = lazy(
  () =>
    import(
      /* webpackChunkName: "BusyRoutes" */ '../pages/verification-tasks/inbox/tabs/done/DoneTab'
    )
);

export const verificationTasksRoutes: PageRouter[] = [
  {
    name: VERIFICATION_TASKS_MAIN_TABS.NEW,
    path: `/${VERIFICATION_TASKS_MAIN_TABS.NEW}`,
    exact: true,
    component: VerificationTasksTableDisplay,
    tabs: []
  },
  {
    name: VERIFICATION_TASKS_MAIN_TABS.ESCALATED,
    path: `/${VERIFICATION_TASKS_MAIN_TABS.ESCALATED}`,
    exact: true,
    component: EscalatedTab,
    tabs: []
  },
  {
    name: VERIFICATION_TASKS_MAIN_TABS.DONE,
    path: `/${VERIFICATION_TASKS_MAIN_TABS.DONE}`,
    exact: true,
    component: DoneTab,
    tabs: []
  }
];
